import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { GatewayURLSCProps, NewPaymentRequest, PaymentBaseData, PaymentList, PaymentProperties, PaymentResponseMessage, PaymentRightsProperties, PaymentSearch } from '../Models/PaymentProperties';
import { AgencyBranchApprovalProperties, UrlRequest } from '../Models/AgencyMasterProperties';
import { ERPBackOffliceBankList } from '../Models/BeneficiaryAccountProperties';

@Injectable({
  providedIn: 'root'
})

export class PaymentService {
  baseUrl = environment.baseUrl;
  backSystemBaseUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  myoptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //'Authorization': token  // if you have to give token
    }),

    // Ignore this part or  if you want full response you have 
    // to explicitly give as 'boby'as http client by default give res.json()
    observe: 'response' as 'body',

    // have to explicitly give as 'blob' or 'json'
    responseType: 'blob' as 'blob'
  };
  constructor(private http: HttpClient) { }

 
  //getPaymentsList(): Observable<PaymentList[]> {
  //  return this.http.get<PaymentList[]>(this.baseUrl + '/Payment/GetPaymentsList')
  //    .pipe(map((data: any) => {

  //      return data;
  //    }), catchError(error => { ////////console.log (error); return throwError(error); }))
  //}
  createDetails(details): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Payment/CreateDocDetails', details, this.httpOptions)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); return null }))
  }
  create(acmadm): Observable<number> {
    return this.http.post<number>(this.baseUrl + '/Payment/AddNewPayment', acmadm, this.httpOptions)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); return null }))

  }
  update(acmadm): Observable<boolean> {

    return (this.http.post<boolean>(this.baseUrl + '/Payment/UpdatePayment', acmadm, this.httpOptions))
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); return null }))


  }
  DownloadFile(relatedDocID: number): Observable<any> {

    ////////console.log (relatedDocID)
    return this.http.get(this.baseUrl + '/Payment/DownloadFile/' + relatedDocID, this.myoptions)
      .pipe(map((resObj: Blob) => { return resObj; })
        , catchError(error => {
          return throwError(error);
        }))
  }


 
  getPaymentById(paymentId, fromRoute): Observable<PaymentProperties> {
    return this.http.get<PaymentProperties>(this.baseUrl + '/Payment/GetPaymentById/' + paymentId + "/" + fromRoute)
      .pipe(map((data: any) => {
        ////////console.log (data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  approvePayment(obj): Observable<boolean> {


    return (this.http.post<boolean>(this.baseUrl + '/Payment/ApprovePayment', obj, this.httpOptions))
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); return null }))
  }
  rejectPayment(obj): Observable<boolean> {

    return (this.http.post<boolean>(this.baseUrl + '/Payment/RejectPayment', obj, this.httpOptions))
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); return null }))
  }
  //update(supplierObj): Observable<boolean> {
  //  return this.http.post<boolean>(this.baseUrl + '/Suppliers/updateSupplier', supplierObj, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      return data;
  //    }), catchError(error => {
  //      ////////console.log (error);
  //      return throwError(error);
  //    }))
  //}
  //checkSupplierName(supplierObj: SuppliersProperties): Observable<boolean> {
  //  return this.http.post<boolean>(this.baseUrl + '/Suppliers/CheckSupplierName', supplierObj, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      return data;
  //    }), catchError(error => {
  //      ////////console.log (error);
  //      return throwError(error);
  //    }))
  //}
  //getSupplierById(id): Observable<SuppliersProperties> {
  //  return this.http.get<SuppliersProperties>(this.baseUrl + '/Suppliers/GetSupplierById/' + id)
  //    .pipe(map((data: any) => {
  //     // ////////console.log (data);
  //      return data;
  //    }), catchError(error => { ////////console.log (error); return throwError(error); }))
  //}


  CheckPaymentRights(agencyId, userId): Observable<PaymentRightsProperties> {
    return this.http.get<PaymentRightsProperties>(this.baseUrl + '/Payment/CheckPaymentRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        ////////console.log (error);
        return throwError(error);
      }))
  }

  ApprovalAgencyBranchCreditLimitS(aba): Observable<AgencyBranchApprovalProperties> {
    return this.http.post<AgencyBranchApprovalProperties>(this.baseUrl + '/Payment/ApprovalAgencyBranchCreditLimitC', aba, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  InprogressPayment(paymentid): Observable<PaymentProperties> {
    return this.http.get<PaymentProperties>(this.baseUrl + '/Payment/CheckTagOfInprogress/' + paymentid)
      .pipe(map((data: any) => {
        //////console.log (data);
        return data;
      }), catchError(error => {
        ////console.log (error);
        return throwError(error);
      }))
  }
  UpdateInprocessTag(obj): Observable<boolean> {
    obj.approval_RejectionUser = Number(localStorage.getItem('UserId')) || 0;
    return this.http.post<boolean>(this.baseUrl + '/Payment/UpdateTagOfInprogress', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  PaymentGatewayPersonDetection(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Payment/PaymentGatewayPersonDetection', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }


  // 27-March-24
  getPaymentBaseData(agencyId: string): Observable<PaymentBaseData> {
    return this.http.get<PaymentBaseData>(this.baseUrl + '/Payment/GetBaseDataPayment?agencyId=' + agencyId)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); }))
  }
  private sharedPaymentData = new NewPaymentRequest();
  public SetRequestData = (data: NewPaymentRequest): void => {
    this.sharedPaymentData = data;
  }
  public GetRequestData = (): NewPaymentRequest => {
    return this.sharedPaymentData;
  }
  public SavePaymentRequest = (paymentRequest: FormData): Observable<PaymentResponseMessage> => {
    return this.http.post<PaymentResponseMessage>(this.baseUrl + '/Payment/SavePaymentRequest', paymentRequest).pipe(
      map((response: PaymentResponseMessage) => {
        return response;
      }), catchError(error => { return throwError(error); }));
  }
  public GetERPBackOfficeBranchList = (requestURL: UrlRequest): Observable<ERPBackOffliceBankList[]> => {
    return this.http.post<ERPBackOffliceBankList[]>(this.baseUrl + '/ERPBackOffice/GetERPBackOfficeBranchList', requestURL).pipe(
      map((response: ERPBackOffliceBankList[]) => {
        return response;
      }), catchError(error => { return throwError(error); }));
  }
  public DeletePayment = (paymentId: string): Observable<boolean> => {
    return this.http.get<boolean>(this.baseUrl + '/Payment/DeletePayment?paymentId=' + paymentId).pipe(map((res: boolean) => {
      return res;
    }), catchError(error => { return throwError(error) }));
  }
  public CancelPayment = (paymentId: number): Observable<boolean> => {
    return this.http.get<boolean>(this.baseUrl + '/Payment/CancelPayment?paymentId=' + paymentId).pipe(map((res: boolean) => {
      return res;
    }), catchError(error => { return throwError(error) }));
  }
  //Related To Magnati
  getURLs(): Observable<GatewayURLSCProps> {
    return this.http.get<GatewayURLSCProps>(this.baseUrl + '/Payment/GetGatewayURLS', this.httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          return throwError(error);
        })
      )
  }

  //end
  //27-March-24 updated
  public GetPaymentById = (paymentId: number): Observable<PaymentProperties> => {
    return this.http.get<PaymentProperties>(this.baseUrl + '/Payment/GetPaymentById?paymentId=' + paymentId)
      .pipe(map((data: any) => {
        //////console.log (data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  public RejectPayment = (obj: PaymentProperties): Observable<PaymentResponseMessage> => {

    return (this.http.post<PaymentResponseMessage>(this.baseUrl + '/Payment/RejectPayment', obj, this.httpOptions))
      .pipe(map((data: PaymentResponseMessage) => {

        return data;
      }), catchError(error => { return throwError(error); }))
  }
  public ApprovePayment(obj: PaymentProperties): Observable<PaymentResponseMessage> {
    return (this.http.post<PaymentResponseMessage>(this.baseUrl + '/Payment/ApprovePayment', obj, this.httpOptions))
      .pipe(map((data: PaymentResponseMessage) => {

        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getPaymentList(paymentListSearch: PaymentSearch): Observable<PaymentList[]> {
    return this.http.post<PaymentList[]>(this.baseUrl + '/Payment/GetPaymentList', paymentListSearch)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getManagerPaymentList(paymentListSearch: PaymentSearch): Observable<PaymentList[]> {
    return this.http.post<PaymentList[]>(this.baseUrl + '/Payment/GetManagerPaymentList', paymentListSearch)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  getManagerByAgecnyPaymentList(userId: number, agencyId: string): Observable<PaymentList[]> {
    return this.http.get<PaymentList[]>(this.baseUrl + '/Payment/GetManagerByAgecnyPaymentList/' + userId + '/' + agencyId)
      .pipe(map((data: any) => {

        return data;
      }), catchError(error => { return throwError(error); }))
  }
//end
}
